import React from 'react';
import { Spinner } from '@woocommerce/blocks-components';
import { __ } from '@wordpress/i18n';

const LoadingMask = ({ loading, children }) => {
	return (
		<div className={`wds-loading-loading-mask ${loading ? 'wc-block-components-loading-mask' : ''}`}>
			{ loading && <Spinner /> }
			<div className="wc-block-components-loading-mask__children">
				{children}
			</div>
			<span className="screen-reader-text">
				{ __( 'Loading…', 'woocommerce' ) }
			</span>
		</div>
	);
};

export default LoadingMask;